export default [
    {icon: "dashboard", title: "Home", name: "Home", i18n: "Home"},
    {icon: "mdi-poll", title: "Service", name: "Service", i18n: "Service"},
    {
        icon: "mdi-file-multiple",
        title: "project_management",
        i18n: "project_management",
        group: "project_management",
        items: [
            {icon: "mdi-buffer", title: "Field_project", name: "Field_project", i18n: "Field_project"},
            {icon: "mdi-file-document", title: "Projects", name: "Projects", i18n: "Projects"},
            {icon: "mdi-tag-multiple", title: "Tags", name: "Tags", i18n: "Tags"},
        ]
    },
    {icon: "mdi-cube-outline", title: "Technology", name: "Technology", i18n: "Technology"},
    {icon: "mdi-infinity", title: "Process", name: "Process", i18n: "Process"},
    {
        icon: "mdi-file-find",
        title: "career_management",
        i18n: "career_management",
        group: "career_management",
        items: [
            {icon: "mdi-account-search", title: "Career", name: "Career", i18n: "Career"},
            {icon: "mdi-account-box", title: "Position", name: "Position", i18n: "Position"},
        ]
    },
    {icon: "mdi-newspaper", title: "News", name: "News", i18n: "News"},
    {icon: "mdi-account-multiple", title: "Partner", name: "Partner", i18n: "Partner"},
    {icon: "mdi-book", title: "Portfolio", name: "Portfolio", i18n: "Portfolio"},
    {icon: "mdi-account-edit", title: "Contact", name: "Contact", i18n: "Contact"},
    {icon: "mdi-file-account", title: "CV", name: "CV", i18n: "CV"},
    {icon: "mdi-phone-in-talk", title: "ConsultationForm", name: "ConsultationForm", i18n: "ConsultationForm"},
];